import React from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Box, Typography, CircularProgress, useTheme } from '@mui/material'
import MiniDepthChart from '../components/charts/MiniDepthChart'
import { useEventDepthData } from '../layers/event_depth_data_binsearch_dictcomp'
import VisxCalendarHeatmap, { type EventLike } from '../components/calendar/VisxCalendarHeatmap'
import { usePastFloodEvents } from '../layers/past_flood_events'
import NavBar from '../components/menu/NavBar'

export const Route = createFileRoute('/calendar')({
  component: CalendarPage,
})

export default function CalendarPage() {
  const theme = useTheme()
  const from = React.useMemo(() => new Date('2020-10-01T00:00:00Z'), [])
  const to = React.useMemo(() => new Date('2026-01-01T00:00:00Z'), [])
  const timeRange = React.useMemo(() => [from, to, false], [from, to])
  const { features, loading } = usePastFloodEvents(timeRange)
  const { features: depthFeatures, loading: depthLoading } = useEventDepthData(timeRange)
  const events = React.useMemo<EventLike[]>(() => {
    if (!features) return []
    return features.map((f) => ({
      date: f.properties.start_time,
      value: Number(f.properties.max_depth_inches) || 0,
      label: f.properties.name,
    }))
  }, [features])

  // const chartFeatures = React.useMemo(() => {
  //   if (!depthFeatures) return []
  //   const grouped: Record<string, { time: Date[]; depth_inches: number[]; feature: any }> = {}
  //   depthFeatures.forEach((f) => {
  //     const id = f.properties.deployment_id || f.id || 'sensor'
  //     if (!grouped[id]) grouped[id] = { time: [], depth_inches: [], feature: f }
  //     grouped[id].time.push(f.properties.time)
  //     grouped[id].depth_inches.push(f.properties.depth_inches)
  //   })
  //   return Object.values(grouped).map((g) => ({
  //     key: g.feature.properties.deployment_id,
  //     label: g.feature.properties.name || g.feature.properties.deployment_id,
  //     data: g.time.map((t, i) => ({ t, d: g.depth_inches[i] })),
  //     feature: g.feature,
  //   }))
  // }, [depthFeatures])

  return (<>
    <NavBar />
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: 'background.default',
        p: { xs: 2, md: 4 },
      }}
    >
      
      <Box sx={{ maxWidth: 1200, mx: 'auto' }}>
        <Typography variant="h3" sx={{ fontWeight: 900, mb: 1 }}>
          Flooding Calendar
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Historic flood intensity by day. Deeper colors indicate higher recorded depth.
        </Typography>

        <Box
          sx={{
            borderRadius: 3,
            border: '1px solid',
            borderColor: theme.palette.divider,
            bgcolor: 'background.paper',
            boxShadow: theme.palette.mode === 'dark' ? '0 8px 30px rgba(0,0,0,0.35)' : '0 10px 30px rgba(0,0,0,0.08)',
            p: { xs: 1.5, md: 2 },
          }}
        >
          {/* <MiniDepthChart
            timeRange={timeRange}
            currentTime={undefined}
            features={chartFeatures as any}
            precip={[]}
            highlightedKey={undefined}
            height={220}
            loading={depthLoading}
            caption={chartFeatures.length ? `${chartFeatures.length} sensors with data` : undefined}
          /> */}
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
              <CircularProgress size={24} />
            </Box>
          ) : (
            <VisxCalendarHeatmap
              events={events}
              fromTime={from}
              toTime={to}
              valueMode="max"
              units='"'
              cell={28}
              gap={5}
            />
          )}
        </Box>
        
      </Box>
    </Box>
    </>
  )
}
